import { Alert, Box, Button } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { useLocation, useNavigate } from "react-router-dom";

import { useUser } from "../../hooks/useUser";

/** Shown on every page once the teacher has declared the game over. */
export default function GameOverBanner() {
  const user = useUser();
  const location = useLocation();
  const navigate = useNavigate();

  const onResultsPage = location.pathname.startsWith("/app/standings/final");
  if (!user?.className?.gameOverAt || onResultsPage) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <Alert
        severity="success"
        icon={<EmojiEventsIcon fontSize="inherit" />}
        sx={{ borderRadius: 0, "& .MuiAlert-message": { width: "100%" } }}
        action={
          <Button
            color="inherit"
            size="small"
            sx={{ whiteSpace: "nowrap" }}
            onClick={() => navigate("/app/standings/final")}
          >
            See the final results
          </Button>
        }
      >
        The game is over! Thanks for playing.
      </Alert>
    </Box>
  );
}
